// engine
import { StateController, delay, dispatcher, platform, respin, serverData } from '@aceroll/core';

// services
import { featureRound } from '../services';
import winAnimation from '../services/winAnimation';

class FeatureSpinResultController extends StateController {
    constructor() {
        super("feature.spin.result");
        this.app = dispatcher.app;
    }

    async onStart() {
        await Promise.all([
            this.animateWins(),
            this.spinDelay()
        ]);

        // platform.onceClickScreen().then(() => {
        //     this.stop();
        // });
        featureRound.addTotalWin(serverData.currentResponse.winAmount);

        serverData.setCurrentResponse();

        this.stop();
    }

    async animateWins() {
        const response = serverData.currentResponse;
        const actions = response.parsed.actions;
        const slotMachine = dispatcher.app.layout.slotMachine;
        // Multiplier animation should be played before the total win animation because the multipliers are included to total win
        await winAnimation.playActions(actions.filter((action) => { return action.type === 'add' }));
        await winAnimation.playActions(actions.filter((action) => { return action.type === 'multiply' }));

        // play total win should show all won line symbols, total win counter, big win if needed. No lines, no scatters.
        await winAnimation.playTotalWin(response);

        if (respin.isStarted()) {
            respin.addTotalWin(response.winAmount)
        }

        const hasMaxWin = serverData.nextResponses.length === 2 && (serverData.nextResponses[0].etn === 'max_win_reached');
        if (hasMaxWin) {
            const totalWin = respin.getTotalWin();
            await this.showBigWinPopup(totalWin, serverData.roundBet);
            this._updateWinFields();
            respin.stop();
        } else if (respin.isStarted() && serverData.featureCount['respin'] <= 0) {
            const totalWin = respin.getTotalWin();
            await this.showBigWinPopup(totalWin, serverData.roundBet);
            this._updateWinFields();
            respin.stop();
        } else if (!respin.isStarted()) {
            await this.showBigWinPopup(response.winAmount, serverData.roundBet);
            this._updateWinFields();
        }

        // then show respin feature land animations. 
        const respinActions = actions.filter((item) => {
            return item.type === 'bonusfeaturewon' && item.data.name === 'respin';
        });
        if (respinActions.length) {
            // add win amount of spin which trigger the respins. The big win after respins shouls include the initial spin win amount
            respin.start();
            respin.addTotalWin(response.winAmount);
        }
        await winAnimation.playActions(respinActions);
        // debugger;

        // move stick symbols to the stick container
        const sticks = actions.filter((action) => { return action.type === 'stick' });
        if (sticks.length > 0) {
            for (let i = 0; i < sticks.length; i++) {
                await slotMachine.stick(sticks[i].data);
            }
            // show stick symbols animations and move to the stick container
        }

        // if no more respins unstick all sticked symbols
        if (hasMaxWin || serverData.featureCount['respin'] <= 0) {
            slotMachine.unstickAll();
            // when respin ended need to hide panel only for FS_1
            if (serverData.featureCount['bonus_1'] > 0) {
                this.app.layout.multiplierPanel.hide();
            }
        }

        // check if the multiply panel should reset
        const resetActions = actions.filter((action) => { return action.type === 'resetMultiplier' });
        if (resetActions[0] && resetActions[0].data.reset) {
            // it happens only in bonus_2, no need to check anything else
            this.app.layout.multiplierPanel.updateMultiplier(1);
        }
    }

    _updateWinFields() {
        platform.setFeatureTotalWin(serverData.currentResponse.totalWinAmount);
    }

    async showBigWinPopup(win, bet) {
        const multiplier = Number(win) / Number(bet);
        const bigWinMinMultiplier = 20;

        if (multiplier >= bigWinMinMultiplier) {
            const popup = dispatcher.app.layout.bigWinPopup;
            platform.onceClickScreen().then(() => popup.handleSkipSequence());

            return popup.show(win, bet);
        }
    }

    async spinDelay() {
        await delay(450);
    }

    onStop() {

    }
}

export default FeatureSpinResultController;